import { PageLink } from "@common-metronic/layout/core"

export const ROUTING_BREADCRUMBS_FOURNISSEURS: Array<PageLink> = [
     {
          title: "Fournisseurs",
     },
]
